// related to JS float bug (https://ellenaua.medium.com/floating-point-errors-in-javascript-node-js-21aadd897bf8)
export const multiplyFloat = (a, b) => Math.round(a * b * 1000) / 1000
export const getPercentInFloat = (a) => Math.round(a * 1000) / 100000
